import { FC, PropsWithChildren, ReactElement, useMemo } from 'react'

import { CheckCircleIcon, InfoIcon, WarningIcon, XCircleIcon } from '@phosphor-icons/react'
import { isDesktop } from 'react-device-detect'
import { Toaster, ToasterProps } from 'sonner'

export const Toast: FC<PropsWithChildren<ToasterProps>> = (props): ReactElement => {
  const position = useMemo(() => (isDesktop ? 'top-right' : 'top-center'), [])

  return (
    <Toaster
      position={position}
      richColors
      theme="dark"
      gap={8}
      toastOptions={{
        duration: 3000,
        classNames: {
          title: 'font-body antialiased',
          toast: 'rounded-lg',
          success: '!bg-success/10 !text-success !border-success',
          error: '!bg-error/10 !text-error !border-error',
          warning: '!bg-warning/10 !text-warning !border-warning',
          info: '!bg-info/10 !text-info !border-info',
        },
      }}
      icons={{
        error: <XCircleIcon size={20} weight="fill" />,
        info: <InfoIcon size={20} weight="fill" />,
        success: <CheckCircleIcon size={20} weight="fill" />,
        warning: <WarningIcon size={20} weight="fill" />,
      }}
      {...props}
    />
  )
}
